import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DashCred } from "src/app/models/dash";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Location } from '@angular/common';
import { sortBy } from 'underscore';
import { TrimFormValuesService } from 'src/app/common/trimmingForm';

@Component({
  selector: "app-search-user",
  templateUrl: "./search-user.component.html",
  styleUrls: ["./search-user.component.css"],
})
export class SearchUserComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private trimFormValuesService: TrimFormValuesService,
  ) { }
  type: string = "user";
  form: UntypedFormGroup;
  users = [];
  dcred = new DashCred();
  org_code: String = "";

  get displayType() {
    switch (this.type) {
      case "user":
        return "front desk";
      case "physicians":
        return "Doctor";
      case "patient":
        return "Patient";
    }
  }

  ngOnInit() {
    this.type = this.route.snapshot.params["type"];
    this.form = this._formBuilder.group({
      name: [null],
    });
  }

  search() {
    this.spinner.show();
    this.users = [];
    let observable = null;
    let data = {
      name: this.form.value.name,
      org_code: localStorage.getItem("orgcode")
    }
    this.trimFormValuesService.trimValues(data);
    if (this.type === "user") {
      observable = this.service.searchFrontDesk(data);
    }

    else if (this.type === "patient") {
      observable = this.service.fetchPatients(data);

    }

    else {
      // observable = this.service.searchDoctorDesk(data);
      this.service.fetchPhysicians(data).subscribe(
        (response) => {
          this.spinner.hide();
          if (response && response['result'] && response['result'].length > 0) {
            this.users = response['result'];
            this.users = sortBy(this.users, 'first_name'); // Data Sorter via underscore.js
            for (let i = 0; i < this.users.length; i++) {
              this.users[i].name = this.users[i].first_name.trim() + ' ' + this.users[i].last_name.trim();
              // this.users[i].ppurl = this.users[i].ppurl;
              this.users[i].avatarimg = this.users[i].ppurl.substring(this.users[i].ppurl.lastIndexOf('/') + 1);
              // console.log("avatar for Phy", this.users[i].avatarimg);
            }
          }
        },
        (error) => {
          this.spinner.hide();
        })
    }
    if (observable)
      observable.subscribe(
        (response) => {
          this.spinner.hide();
          if (response && response.length > 0) {
            this.users = response;
            this.users = sortBy(this.users, 'first_name'); // Data Sorter via underscore.js

            for (let i = 0; i < this.users.length; i++) {
              this.users[i].name = this.users[i].first_name.trim() + ' ' + this.users[i].last_name.trim();
              //this.users[i].ppurl = this.users[i].ppurl;
              this.users[i].avatarimg = this.users[i].ppurl.substring(this.users[i].ppurl.lastIndexOf('/') + 1);
              //console.log("avatar for Pat/FDSesk", this.users[i].avatarimg);
            }
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );

  }
  getback() {
    this.location.back();
  }
}
